module.exports = __webpack_public_path__ + "img/MNG.9ffa21ee.gif";